<template>
  <div>
      <el-row>
          <el-col :span="24">
              <h1>KP UPLOAD EXCEL</h1>
          </el-col>
          <el-col :span="24">
              <el-upload
                class="upload-demo"
                ref="upload"
                action="''"
                :limit="1"
                :auto-upload="false"
                :on-exceed="handleExceedExcel"
                :on-change="handleUpload"
                :before-remove="onRemoveFile"
                >
                <el-button slot="trigger" size="small" type="primary">select file</el-button>
                <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Save</el-button>
                </el-upload>
          </el-col>
          <el-col :span="24" v-if="loading">
              <h2><i class="el-icon-loading"></i> Progress : {{currentApi}}/{{list.length}}</h2>
          </el-col>
          <el-col :span="24" class="text-left">
              <h2>
              ตารางแสดงรายการที่ไม่สำเร็จ
              </h2>
          </el-col>
          <el-col :span="24">
                <el-table
                :data="listError"
                style="width: 100%">
                    <el-table-column fixed label="row excel fail">
                            <template slot-scope="props">
                                {{props.row.rowFail}}
                            </template>
                        </el-table-column>
                    <el-table-column
                        fixed
                        label="status"
                        width="100">
                        <template slot-scope="props">

                                <template v-if="props.row.status === 3">
                                    <!-- <i class="el-icon-close"></i> -->
                                    <el-tooltip :content="props.row.message" placement="top">
                                        <i class="el-icon-info"></i>
                                    </el-tooltip>
                                </template>
                        </template>
                    </el-table-column>
                    <el-table-column label="order_number">
                        <template slot-scope="props">
                            {{props.row.param.order_number}}
                        </template>
                    </el-table-column>
                    <el-table-column label="payment_type">
                        <template slot-scope="props">
                            {{props.row.param.payment_type}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_name">
                        <template slot-scope="props">
                            {{props.row.param.dst_name}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_phone_number">
                        <template slot-scope="props">
                            {{props.row.param.dst_phone_number}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_address">
                        <template slot-scope="props">
                            {{props.row.param.dst_address}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_sub_district">
                        <template slot-scope="props">
                            {{props.row.param.dst_sub_district}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_district">
                        <template slot-scope="props">
                            {{props.row.param.dst_district}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_province">
                        <template slot-scope="props">
                            {{props.row.param.dst_province}}
                        </template>
                    </el-table-column>
                    <el-table-column label="dst_zipcode">
                        <template slot-scope="props">
                            {{props.row.param.dst_zipcode}}
                        </template>
                    </el-table-column>
                    <el-table-column label="delivery_cost">
                        <template slot-scope="props">
                            {{props.row.param.delivery_cost}}
                        </template>
                    </el-table-column>
                    <el-table-column label="remark">
                        <template slot-scope="props">
                            {{props.row.param.remark}}
                        </template>
                    </el-table-column>
                    <el-table-column label="products" width="300">
                        <template slot-scope="props">
                            <div class="talbe-p">
                                <p><b>product_sku : </b>{{props.row.param.products[0].product_sku}}</p>
                                <p><b>product_name : </b>{{props.row.param.products[0].product_name}}</p>
                                <p><b>product_weight : </b>{{props.row.param.products[0].product_weight}}</p>
                                <p><b>quantity : </b>{{props.row.param.products[0].quantity}}</p>
                                <p><b>price: </b>{{props.row.param.products[0].price}}</p>
                            </div>
                        </template>
                    </el-table-column>
              </el-table>
          </el-col>
      </el-row>
  </div>
</template>

<script>
import xlsx from 'xlsx'
import fgApi from '@/services/fillgoods'

export default {
    name: 'kpUploadOrder',
    data () {
        return {
            list: [],
            listError: [],
            currentApi: 0,
            loading: false
        }
    },
    methods: {
        handleExceedExcel (files, fileList) {
            this.$notify.error({
                title: 'ผิดพลาด',
                message: 'กรุณาอัพโหลดทีละ 1 ไฟล์',
                duration: 6000
            })
        },
        handleUpload (file) {
            let reader = new FileReader()
            reader.onload = e => {
                this.list = []
                let data = e.target.result
                let workbook = xlsx.read(data, { type: 'binary' })
                let wsname = workbook.SheetNames[0]
                let ws = workbook.Sheets[wsname]
                let readData = xlsx.utils.sheet_to_json(ws,
                    {
                        header: ['order_number', 'payment_type', 'product_sku', 'product_name', 'quantity', 'price', 'delivery_cost', 'weight', 'remark', 'dst_name', 'dst_phone_number', 'dst_address', 'dst_sub_district', 'dst_district', 'dst_province', 'dst_zipcode'],
                        blankRows: false,
                        defval: null
                    }
                )
                let dataWithoutKey = readData.slice(1, readData.length)

                if (dataWithoutKey.length > 0) {
                    dataWithoutKey.forEach((rd, index) => {
                        const params = {
                            status: 0,
                            param: {
                                order_number: String(rd.order_number),
                                payment_type: parseInt(rd.payment_type),
                                dst_name: String(rd.dst_name),
                                dst_phone_number: String(rd.dst_phone_number),
                                dst_address: String(rd.dst_address),
                                dst_sub_district: String(rd.dst_sub_district),
                                dst_district: String(rd.dst_district),
                                dst_province: String(rd.dst_province),
                                dst_zipcode: String(rd.dst_zipcode),
                                delivery_cost: parseInt(rd.delivery_cost),
                                remark: String(rd.remark),
                                products: [
                                    {
                                        product_sku: String(rd.product_sku),
                                        product_name: String(rd.product_name),
                                        product_weight: parseInt(rd.weight),
                                        quantity: parseInt(rd.quantity),
                                        price: parseInt(rd.price)
                                    }
                                ]
                            }
                        }
                        this.list.push(params)
                    })
                } else {
                    this.$notify.error({
                        title: 'ผิดพลาด',
                        message: 'ไฟล์ Excel ข้อมูลไม่ครบถ้วน',
                        duration: 6000
                    })
                    this.$refs['upload'].clearFiles()
                    throw e
                }
            }
            reader.readAsBinaryString(file.raw)
        },
        async submitUpload () {
            this.currentApi = 0
            this.listError = []
            this.loading = true
            for (let index = 0; index < this.list.length; index++) {
                const element = this.list[index]
                try {
                    element.status = 1
                    // this.$set(this.list, index, element)
                    const result = await fgApi.order.kpCreateOrder(element.param)
                    this.currentApi++
                    if (result.success) {
                        element.status = 2
                        // this.$set(this.list, index, element)
                    } else {
                        element.status = 3
                        element.message = result.message
                        element.rowFail = index + 1
                        // this.$set(this.list, index, element)
                        this.listError.push(element)
                    }
                } catch (error) {
                    element.status = 3
                    element.message = error
                    element.rowFail = index + 1
                    this.listError.push(element)
                    // this.$set(this.list, index, element)
                }
            }
            this.$notify({
                title: 'Success',
                message: 'อัพโหลดสำเร็จ',
                type: 'success'
            })
            this.loading = false
        },
        onRemoveFile () {
            this.loading = false
            this.list = []
            this.currentApi = 0
            this.listError = []
        }
    }
}
</script>

<style lang="scss" scoped>
p {
    margin :0 !important;
}
</style>
